export const FAKE_VESSEL_IMO_NUMBER_WARNING = "⚠️ You are testing using a fake vessel.";
export const TECH_FORM_STEP_PAGES: Record<number, string> = {
  1: "vessel-detail",
  2: "design-detail",
  3: "draft",
  4: "antifouling-detail",
  5: "port-calls",
  6: "seca",
  7: "slow-steaming",
  8: "power-management",
  9: "confirm-sub",
};
export const TECH_FORM_RATING_OPTIONS = [
  { value: "EEDI", label: "EEDI" },
  { value: "EEXI", label: "EEXI" },
];
export const TECH_FORM_GENSET_COUNTS = ["1", "2", "3", "4"];

export const TECH_FORM_TYPED_DATE_PATTERN = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
